import { render } from "./aboutUs.vue?vue&type=template&id=cde58930&scoped=true"
const script = {}

import "./aboutUs.vue?vue&type=style&index=0&id=cde58930&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cde58930"]])

export default __exports__